/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./recovery-page.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../recovery-box/recovery-box.component.ngfactory";
import * as i3 from "../recovery-box/recovery-box.component";
import * as i4 from "../login.service";
import * as i5 from "../../header/live-agent-support/live-agent-support.service";
import * as i6 from "@ng-bootstrap/ng-bootstrap";
import * as i7 from "./recovery-page.component";
var styles_RecoveryPageComponent = [i0.styles];
var RenderType_RecoveryPageComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_RecoveryPageComponent, data: {} });
export { RenderType_RecoveryPageComponent as RenderType_RecoveryPageComponent };
export function View_RecoveryPageComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "lp2-recovery-box", [], null, null, null, i2.View_RecoveryBoxComponent_0, i2.RenderType_RecoveryBoxComponent)), i1.ɵdid(1, 49152, null, 0, i3.RecoveryBoxComponent, [i4.LoginService, i5.LiveAgentSupportService, i6.NgbModal], null, null)], null, null); }
export function View_RecoveryPageComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "lp2-recovery-page", [], null, null, null, View_RecoveryPageComponent_0, RenderType_RecoveryPageComponent)), i1.ɵdid(1, 114688, null, 0, i7.RecoveryPageComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var RecoveryPageComponentNgFactory = i1.ɵccf("lp2-recovery-page", i7.RecoveryPageComponent, View_RecoveryPageComponent_Host_0, {}, {}, []);
export { RecoveryPageComponentNgFactory as RecoveryPageComponentNgFactory };
//# sourceMappingURL=recovery-page.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/login/recovery-page/recovery-page.component.ngfactory.js
// module id = 1668
// module chunks = 27 28 29